var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('base-material-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('v-row',{staticClass:"d-s-flex"},[_c('v-col',{class:_vm.$vuetify.breakpoint.smAndDown
							? 'text-center display-2 font-weight-light'
							: 'display-2 font-weight-light',attrs:{"cols":"12"}},[_vm._v(" ניהול תוכניות ")]),_c('v-col',{class:{
						'd-flex justify-center': _vm.$vuetify.breakpoint.smAndDown
					},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"ml-3",attrs:{"to":{
							name: 'project-subscriptions',
							params: { id: _vm.project.id }
						}}},[_vm._v(" Show Subscriptions ")]),_c('v-btn',{attrs:{"to":{
							name: 'plan-create',
							params: { projectId: _vm.project.id }
						}}},[_vm._v(" Add Plan ")])],1)],1)]},proxy:true}])},[_c('plans-display',{attrs:{"plans":_vm.project.plans}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }